import { withRouter } from 'react-router'
import SearchPageContents from './SearchPageContents'

export default withRouter((SearchPageContents))
